<template>
    <div class="personPage">
        <v-search :formContent="formContent" :SearchForm="SearchForm" :inline="true" :optareBtn="optareBtn"
            @resetFn="resetFn" @searchFn="getListFn" @confirmFn="getListFn" @addFn="addFn" @DelFn="DelFn" @userFn="userFn">
        </v-search>
        <div class="componentPage">
            <STable :req="contactsList" :params="[SearchForm]" :columns="columns" ref="stable" @selectData="choozeTableFn">
            </STable>
        </div>
        <!-- 新增 -->
        <Dialog :customerArray="customerArray" :isShow.sync="isShow" :title="title" ref="vForm" />
        <!-- 详细&编辑 -->
        <EditDetail :customerArray="customerArray" :isShow.sync="isShowBool" :detailObj="detailObj" :title="title"
            ref="EditDetail" />
    </div>
</template>

<script>
import mixinForm from '@/utils/formMixins.js';
import getRange from '@/utils/getRange.js';
import { shareScope } from '@/api/modules/public.js';
import { accessRangeTree } from '@/api/api.js';
import { contactsList, contactsDetail, contactsDel, contactsSync } from '@/api/modules/contact.js';

import Dialog from './Dialog.vue';
import EditDetail from './EditDetail.vue';

import columns from './mixin/columns';
import STable from '@/components/STable/STable.vue';

export default {
    mixins: [mixinForm, getRange, columns],
    components: {
        Dialog,
        EditDetail,
        STable
    },
    computed: {
        i18n() {
            return this.$i18n.locale;
        },
        isSysAdmin() {
            const currentUser = this.$store.getters.userInfo.scope;
            return (currentUser.sysScope && currentUser.sysAdmin) || (currentUser.sysScope && !currentUser.sysAdmin);
        }
    },
    data() {
        return {
            contactsList,
            formContent: [
                {
                    id: 1,
                    text: 'public.table_name',
                    type: 'input',
                    paramsName: 'name',
                    isChooze: true
                },
                {
                    id: 2,
                    text: 'labelTitle.Range',
                    type: 'select',
                    paramsName: 'sceneId',
                    selectParam: [],
                    isChooze: false
                }
            ],
            SearchForm: {
                sceneId: null,
                name: null
            },
            optareBtn: [
                {
                    id: 1,
                    icon: '',
                    vHas: ['incubatorAddCarrier'],
                    text: 'public.btn_new',
                    method: 'addFn'
                },
                {
                    id: 2,
                    icon: '',
                    vHas: ['delRange'],
                    text: 'buttonTitle.Delete',
                    method: 'DelFn'
                },
                {
                    id: 3,
                    icon: '',
                    vHas: ['delRange'],
                    text: 'public.sync_user',
                    method: 'userFn'
                }
            ],
            isShowBool: false,
            detailObj: {},
            choozeTable: [],
            customerArray: []
        };
    },
    created() {
        if (!this.isSysAdmin) {
            this.formContent.pop();
        }
        this.getRangeFn();
    },
    methods: {
        getRangeFn() {
            this.getCustomerList({
                type: 1,
                tab: 1
            }).then(({ result }) => {
                this.customerArray = result;
                if (this.$store.state.type === 2 || this.$store.state.type === 3) {
                    this.formContent[1].selectParam = result.map(item => {
                        return {
                            value: item.id,
                            label: item.name
                        };
                    });
                    this.formContent[1].selectParam.unshift({
                        value: null,
                        label: 'public.please'
                    });
                }
            });
        },
        /** 表格勾选 */
        choozeTableFn(array) {
            this.choozeTable = array;
        },
        resetFn() {
            this.SearchForm = {
                sceneId: null,
                name: null,
                iDisplayStart: 0,
                iDisplayLength: 15
                // type: '0'
            };
            this.getListFn();
        },
        getListFn() {
            this.$refs.stable.getList();
        },
        addFn() {
            this.isShow = true;
            this.title = $t('integration.new_contact_information');
            this.$nextTick(() => {
                this.$refs.vForm.clearValidate();
            });
        },
        detailRow(row) {
            this.title = `[${row.name}] ${$t('public.contact_details')}`;
            this.isShowBool = true;
            this.$nextTick(() => {
                this.$refs.EditDetail.clearValidate();
                this.$refs.EditDetail.isEdit = true;
            });
            contactsDetail({ id: row.id }).then(({ result }) => {
                this.detailObj = result;
            });
        },
        DelFn() {
            if (this.choozeTable.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
            let flag = true;

            for (const item of this.choozeTable) {
                if (item.sign === 1) {
                    flag = false;
                    break;
                }
            }
            if (!flag) return this.$message.warning($t('integration.the_selected_data_has_a_synchronization_user_c__which_cannot_be_deleted'));
            const ids = this.choozeTable.map(item => item.id);

            this.TODOTIPDEL(ids);
        },
        // delRow(row) {
        //   this.TODOTIPDEL([row.id])
        // },
        /**
         *
         * @param {*param 选中数据id} param string
         */
        TODOTIPDEL(param) {
            this.$confirm(this.$t('messageTitle.DeleteToContinue')).then(() => {
                contactsDel(param).then(({ result }) => {
                    if (result === 1) {
                        this.getListFn();
                        this.$message.success(this.$t('public.tip_del_succ').toString());
                    } else {
                        this.$message.error(this.$t('public.tip_del_fail'));
                    }
                });
            });
        },
        // 同步用户
        userFn() {
            this.$loading.show({
                text: '正在同步中,请勿关闭页面...'
            });
            contactsSync()
                .then(({ result }) => {
                    if (result === 0) {
                        this.$message.error($t('integration.synchronization_failed'));
                    } else if (result === 1) {
                        this.$loading.hide();
                        this.$message.success($t('integration.synchronization_successful'));
                        this.getListFn();
                        (this.isShowDialog = false), this.$parent.getListFn();
                    } else if (result === 2) {
                        this.$message.warning($t('integration.same_record_exists_c__duplicate_record_skipped'));
                    } else {
                        this.$message.error(this.$t('public.unknown_error'));
                    }
                })
                .finally(() => {
                    this.$loading.hide();
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.personPage {
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;

    .componentPage {
        flex: 1;

        .pagination {
            padding-top: 0;
            padding-right: 15px !important;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
}

::v-deep .orange {
    color: orange !important;
}
</style>
